var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRootCauseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solutions",
    transform: "translate(-1003.000000, -9981.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(1003.000000, 9981.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-43-Copy-4",
    fill: "#DBF6E4",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-message-load-HTZF8JXLVC",
    transform: "translate(17.000000, 21.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.16666667 C0,3.20863611 3.22356,0 7.2,0 L33.6,0 C40.22736,0 45.6,5.34771889 45.6,11.9444444 L45.6,29.8792667 C45.6,30.4652611 45.67224,31.0488667 45.81504,31.6174222 L47.92824,40.0318056 C48.13632,40.8595556 47.8848,41.7348444 47.26848,42.3282444 C46.6524,42.9214056 45.76488,43.1426167 44.94072,42.9080278 L29.43336,38.4979 C28.79016,38.31515 28.1244,38.2222222 27.45552,38.2222222 L12,38.2222222 C5.372592,38.2222222 0,32.8744556 0,26.2777778 L0,7.16666667 Z M7.2,4.77777778 C5.874528,4.77777778 4.8,5.84733111 4.8,7.16666667 L4.8,26.2777778 C4.8,30.2359278 8.02356,33.4444444 12,33.4444444 L27.45552,33.4444444 C28.57056,33.4444444 29.68008,33.5990056 30.75216,33.9040667 L42.26376,37.1778 L41.15832,32.7762722 C40.92024,31.8288389 40.8,30.8558444 40.8,29.8792667 L40.8,11.9444444 C40.8,7.98641389 37.57656,4.77777778 33.6,4.77777778 L7.2,4.77777778 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,19.1111111 C16.8,20.4304944 15.725472,21.5 14.4,21.5 C13.074528,21.5 12,20.4304944 12,19.1111111 C12,17.7917278 13.074528,16.7222222 14.4,16.7222222 C15.725472,16.7222222 16.8,17.7917278 16.8,19.1111111 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,19.1111111 C26.4,20.4304944 25.32552,21.5 24,21.5 C22.67448,21.5 21.6,20.4304944 21.6,19.1111111 C21.6,17.7917278 22.67448,16.7222222 24,16.7222222 C25.32552,16.7222222 26.4,17.7917278 26.4,19.1111111 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,19.1111111 C36,20.4304944 34.92552,21.5 33.6,21.5 C32.27448,21.5 31.2,20.4304944 31.2,19.1111111 C31.2,17.7917278 32.27448,16.7222222 33.6,16.7222222 C34.92552,16.7222222 36,17.7917278 36,19.1111111 Z",
    id: "Shape",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootCauseIcon);
export default __webpack_public_path__ + "static/media/root-cause-icon.b3d68acabe1990b5b9cb7e1bc6d4a04d.svg";
export { ForwardRef as ReactComponent };